<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>




		<div class="read">
			<div class="read-hd">
				<q-title title="预约取号" :time="time" ></q-title>
				<q-step :step="1"></q-step>
			</div>

	
			
			
			<div  class="read-bd-title fc"><i ></i><h3 >请核对个人基本信息</h3></div>
			
			
			
			<div class="user-basicInfo k-box b1">
				<ul>
					<li>
					
						<span>姓名：</span>
						<b>某某</b>
					</li>
					<li>
						
						<span>性别：</span>
						<b>女</b>
					</li>

					<li>
						
						<span>出生日期：</span>
						<b>2000-01-01</b>
					</li>
					<li>
						
						<span>证件号码：</span>
						<b>41150320000527****</b>
					</li><li>
						
						<span>挂号科室：</span>
						<b>外科</b>
					</li><li>
						
						<span>就诊日期：</span>
						<b>2021-01-01</b>
					</li><li>
						
						<span>挂号金额：</span>
						<b>100元</b>
					</li><li>
						
						<span>就诊医生：</span>
						<b>张三</b>
					</li><li>
						
						<span>就诊时间：</span>
						<b>09:04:35</b>
					</li>
				</ul>
			</div>
			
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png">
					<span>首页</span>
				</a>
				<a class="btn-orange fcc" @click="enter">
					<img src="../../assets/icon/icon-ok.png">
					<span>确认</span>
				</a>
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png">
					<span>返回</span>
				</a>
			</div>
			
		</div>	
		
		<!-- 缴费成功 -->
		<q-pop-payCost  v-if="payCostShow" @close-read="closePayCost" msg="就诊凭条打印成功<br/>请取走就诊凭条。"></q-pop-payCost>
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	
	import qPopPayCost from '@/components/q-pop/q-pop-payCost.vue';
	export default {
		components: {
			qHead,
			qBanner,
			qStep,
			qTitle,
			qPopPayCost
		},
		data() {
			return {
				
				time:86,
				
				payCostShow:false
			}
		},
		mounted() {

		},
		methods: {
			enter(){
				this.payCostShow=true
			},
			closePayCost(data){
				this.payCostShow=false
			},	
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style scoped lang="less">
	
</style>
